let code = 'pu';
let codeAPI = 'pu';
export const apiConstants = {
    code: `${code}`,
    codeAPI: `${codeAPI}`,
};